import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveAdministradora({ commit }, data) {
      try {
        return await api.post('/administradoras', data)
      } catch (error) {
        throw error
      }
    },

    async getAdministradoras({ commit }, data) {
      try {
        let url = `/administradoras`

        if (data && data.status) {
          url += `?status=${data.status}`
        }

        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getAdministradora({ commit }, administradoraId) {
      try {
        const response = await api.get(`/administradoras/${administradoraId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateAdministradora({ commit }, data) {
      try {
        return await api.put(`/administradoras/${data.id}`, data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
